import { useMemo } from "react";
import { t, useTranslation } from "@/langs/useTranslation";

function getOSType(taskType, ext) {
  if (!ext) return "";
  let OSType = ext.split(":")[0].toLowerCase();
  if (OSType === "android") {
    OSType = "Android";
  } else if (OSType === "windows") {
    OSType = "Windows";
  } else {
    OSType = "";
  }
  return taskType === "start_app" || taskType === "close_app"
    ? OSType
      ? `(${OSType})`
      : ""
    : "";
}

function ScheduleTaskType({ data }) {
  const { t } = useTranslation("powerManagement");

  const taskMap = {
    start: t("dialog.powerOn"),
    shutdown: t("dialog.powerOff"),
    wake_up: t("dialog.wakeUp"),
    sleep: t("dialog.sleep"),
    open_screen: t("dialog.wakeUp"),
    close_screen: t("dialog.sleep"),
    reboot: t("dialog.reboot"),
    start_app: t({ defaultMessage: "执行应用" }),
    close_app: t({ defaultMessage: "关闭应用" })
  };

  const taskType = data.task_type || data.taskType;
  const OSType = useMemo(
    () => getOSType(taskType, data.ext),
    [taskType, data.ext]
  );

  return (
    <>
      {taskMap[taskType]}
      {OSType}
    </>
  );
}

export function getScheduleTaskType(taskType, ext) {
  const taskMap = {
    start: t("dialog.powerOn", null, "powerManagement"),
    shutdown: t("dialog.powerOff", null, "powerManagement"),
    wake_up: t("dialog.wakeUp", null, "powerManagement"),
    sleep: t("dialog.sleep", null, "powerManagement"),
    open_screen: t("dialog.wakeUp", null, "powerManagement"),
    close_screen: t("dialog.sleep", null, "powerManagement"),
    reboot: t("dialog.reboot", null, "powerManagement"),
    start_app: t({ defaultMessage: "执行应用" }),
    close_app: t({ defaultMessage: "关闭应用" })
  };

  const OSType = getOSType(taskType, ext);

  return `${taskMap[taskType]}${OSType}`;
}

export default ScheduleTaskType;
